import { Link } from "react-router-dom";
import constants from "Constants";
import { SetDocumentTitle } from "utils/SetDocumentTitle";
import MasterSidebar from "components/navigation/MasterSidebar";
import SidebarPage from "../templates/SidebarPage";
import Accordion from "react-bootstrap/Accordion";
import { Commandments } from "lib/data/Commandments";

interface IAccordionItem {
  id: string;
  url: string;
  summary: string;
  name: string;
  subTitle: string;
}

function VerticalAccordion({ items }: { items: IAccordionItem[] }) {
  return (
    <Accordion defaultActiveKey={Object.keys(items)[0]}>
      {Object.values(items).map((item, i) => {
        return (
          <Accordion.Item eventKey={item.id} key={item.id}>
            <Accordion.Header>
              <div className="w-100 py-4 px-4">
                <h5 className="text-left w-100">
                  <Link to={item.url} className="text-body no-underline underline-on-hover">
                    {item.name}
                  </Link>
                </h5>
                <h3 className="lead text-end fs-5 pe-5 w-100">{item.subTitle}</h3>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="px-4 py-4">
                <div>{item.summary}</div>

                <div className="text-end">
                  <Link to={item.url}>
                    <button className="btn btn-primary">Check out Commandment #{i + 1}</button>
                  </Link>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
}

export default function CommandmentsHome() {
  SetDocumentTitle("Commandments Home");

  return (
    <SidebarPage.Page>
      <SidebarPage.Sidebar>
        <MasterSidebar />
      </SidebarPage.Sidebar>
      <SidebarPage.Content>
        <div className="w-100 px-3">
          <div className="container mb-5" style={{ maxWidth: constants.maxPageWidth }}>
            <div className=" my-4">
              <div className="text-center mb-4">
                <h1 className="my-5">The 10 Commandments of Business Strategy</h1>
              </div>
            </div>

            <div className="w-content mx-auto">
              <VerticalAccordion items={Object.values(Commandments)} />
            </div>
          </div>
        </div>
      </SidebarPage.Content>
    </SidebarPage.Page>
  );
}
